import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import MuiMenuItem from '@mui/material/MenuItem';
const MuiMenuItemRoot = styled(MuiMenuItem)(({
  theme: {
    palette
  }
}) => ({
  paddingTop: 0,
  paddingBottom: 0,
  '&.MuiMenuItem-root': {
    minHeight: 48
  },
  '& .MenuItem__iconContainer': {
    color: 'inherit',
    minWidth: 'auto'
  },
  '& .MenuItem__textContainer': {
    color: palette.text.onMain,
    flex: '0 1 auto',
    '& > span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block'
    }
  }
})) as typeof MuiMenuItem;
function MenuItem(t0) {
  const $ = _c(27);
  let otherProps;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== t0) {
    ({
      children: t1,
      className: t2,
      Component: t3,
      icon: t4,
      isIconOnRight: t5,
      label: t6,
      subLabel: t7,
      ariaLabel: t8,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    otherProps = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
  }
  const children = t1 === undefined ? null : t1;
  const className = t2 === undefined ? "" : t2;
  const Component = t3 === undefined ? "div" : t3;
  const MenuIcon = t4 === undefined ? null : t4;
  const isIconOnRight = t5 === undefined ? false : t5;
  const label = t6 === undefined ? "" : t6;
  const subLabel = t7 === undefined ? "" : t7;
  const ariaLabel = t8 === undefined ? "Show menu" : t8;
  let iconElement;
  if (MenuIcon) {
    let t9;
    if ($[10] !== MenuIcon || $[11] !== ariaLabel) {
      t9 = typeof MenuIcon === "function" ? <MenuIcon aria-label={ariaLabel} /> : MenuIcon;
      $[10] = MenuIcon;
      $[11] = ariaLabel;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    const MenuIconNode = t9;
    let t10;
    if ($[13] !== MenuIconNode) {
      t10 = <ListItemIcon className="MenuItem__iconContainer">{MenuIconNode}</ListItemIcon>;
      $[13] = MenuIconNode;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    iconElement = t10;
  } else {
    iconElement = null;
  }
  const t9 = !isIconOnRight && iconElement;
  const t10 = !isIconOnRight && !iconElement;
  let t11;
  if ($[15] !== label || $[16] !== subLabel || $[17] !== t10) {
    t11 = <ListItemText className="MenuItem__textContainer" inset={t10} primary={label} secondary={subLabel} />;
    $[15] = label;
    $[16] = subLabel;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = isIconOnRight && iconElement;
  let t13;
  if ($[19] !== Component || $[20] !== children || $[21] !== className || $[22] !== otherProps || $[23] !== t11 || $[24] !== t12 || $[25] !== t9) {
    t13 = <MuiMenuItemRoot className={className} component={Component} {...otherProps}>{t9}{t11}{t12}{children}</MuiMenuItemRoot>;
    $[19] = Component;
    $[20] = children;
    $[21] = className;
    $[22] = otherProps;
    $[23] = t11;
    $[24] = t12;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}
export default MenuItem;